export default "__VITE_ASSET__CvmhTS6A__"